<mat-toolbar class="container announcement-bar-content m-auto">
  <div class="d-flex align-items-center justify-content-between w-100">
    <ng-content></ng-content>
    <a class="opening-hours"
      [href]="routeTranslator.translateAMRoute(['HEADER.OPENING_HOURS.SLUG' | translate])">{{"HEADER.OPENING_HOURS.LABEL"
      | translate}}</a>
    <ala-social-links class="d-flex ml-auto social-links"></ala-social-links>
  </div>
</mat-toolbar>